import React from 'react';
import '../styles/package-widget.css';
import { FaWhatsapp } from "react-icons/fa";
import { VscCallOutgoing } from "react-icons/vsc";

const PackageWidget = (pps) => {

  const TableBody = () => {        
    return (
        <tbody>          
                <tr>
                    <td>{pps.pms.hrsKms}</td>                    
                    <td>{pps.pms.nonACPrice}</td>
                    <td>{pps.pms.acPrice}</td>
                </tr>           
        </tbody>
    );
  }

  const handleWhatsAppClick = () => {
    const whatsappNumber = '919092483530'; // Replace with the desired number
    const defaultMessage = `Hello, I would like to inquire about ${pps.pms.title}.`; // Replace with your default message
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(defaultMessage)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleEnquiryClick = () => {
    const phoneNumber = '919092483530'; // Replace with the desired number
    const telephoneUrl = `tel:${phoneNumber}`;
    window.open(telephoneUrl, '_system');
  };

  return (
    <div className="tempo-container">      
        <img src={pps.pms.img} alt={pps.pms.title} />
        <div className="tempo-details">
          <h2>{pps.pms.title}</h2>
          <div>
            <table>
              <thead>
                <tr>
                  <th>Hrs/Kms</th>
                  <th>Non-AC</th>
                  <th>AC</th>
                </tr>
              </thead>
              <TableBody />
            </table>
          </div>
          <div className="extras">
            <p>Driver Betta: {pps.pms.driverBeta}</p>
            <p>Extra hrs: {pps.pms.extraHrs}</p>
          </div>
          <div className="buttons">
            <button className="whatsapp" onClick={handleWhatsAppClick}>
              <FaWhatsapp size={24}/> WhatsApp
            </button>
            <button className="enquiry" onClick={handleEnquiryClick}>
              <VscCallOutgoing size={24}/> Enquiry Now
            </button>
          </div>
        </div>     
    </div>
  );
};

export default PackageWidget;